import React, { Component } from 'react';
import SelectSearch from 'react-select-search';


class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /*------------------------------------------------Page Data--------------------------------------------------------- */
      // regiondata:this.props.address,
      country: 'EMEA',
      workdaylocation: this.props.location,
      placeholderName: this.props.placeholderName,
    }
  }
  renderOption = (option, state, props) => {
    return <div title={option.name} >{option.name} </div>;
  }

  render() {
    return (
      <div>
        <h4 className='inputlebelheader'>{this.state.workdaylocation} <span className="astrik">{this.props.astrik}</span></h4>
        <SelectSearch
          mode="input"
          value={this.props.locationselected.value ? this.props.locationselected.value : this.props.previouslocation}
          options={this.props.region ? this.props.region : []}
          placeholder={this.state.placeholderName}
          onChange={e => this.props.regiondata(e)}
          renderOption={this.renderOption}
          autoComplete='no'
        />
      </div>
    );
  }
}

export default Dropdown;